import { render } from "./index.vue?vue&type=template&id=a8760082&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a8760082&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=a8760082&lang=scss"
script.render = render
script.__scopeId = "data-v-a8760082"

export default script